var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('PowraTitle', {
    attrs: {
      "avatar": 'F',
      "title": _vm.$vuetify.t('$vuetify.powra.otherControlMeasuresSafetyPrecautionsTaken')
    }
  }), _c('v-flex', {
    staticClass: "no-top-border",
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-checkbox', {
    model: {
      value: _vm.adequateControlsToHazards,
      callback: function callback($$v) {
        _vm.adequateControlsToHazards = $$v;
      },
      expression: "adequateControlsToHazards"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.powra.adequateControlsToHazards')) + "\n      ")])])], 1), _vm.adequateControlsToHazards == false ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-text', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n      " + _vm._s(_vm.$vuetify.t('$vuetify.powra.listAdditionalControlMeasures')) + "\n    ")])], 1) : _vm._e(), _vm.adequateControlsToHazards == false ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "",
      "outline": ""
    },
    on: {
      "blur": function blur($event) {
        return _vm.newControl(_vm.controlText);
      }
    },
    model: {
      value: _vm.controlText,
      callback: function callback($$v) {
        _vm.controlText = $$v;
      },
      expression: "controlText"
    }
  })], 1) : _vm._e(), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline indigo darken-4 white--text",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.dialogs.delete.headline')) + "\n      ")]), _c('v-card-text', [_vm._v("\n        C" + _vm._s(_vm.selectedControl) + ".\n        " + _vm._s(_vm.selectedControl ? _vm.controls[_vm.selectedControl] : '') + "\n      ")]), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.dialogs.delete.text')) + "\n      ")]), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.cancel')) + "\n        ")]), _c('v-btn', {
    attrs: {
      "color": "red"
    },
    on: {
      "click": function click($event) {
        _vm.selectedControl ? _vm.deleteControl(_vm.selectedControl) : '';
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.dialogs.delete.agree')) + "\n        ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }